import { jsx as i } from "react/jsx-runtime";
import "react";
import { classes as s } from "../../../../utils/helpers.js";
import '../../../../assets/Figure.css';const r = {
  "figure-slide": "_figure-slide_6uaj0_1",
  "figure-slide__figure": "_figure-slide__figure_6uaj0_9",
  "figure-slide--captioned-image": "_figure-slide--captioned-image_6uaj0_36"
};
function n({ images: l = [{ url: "", altText: "", caption: "" }], imagesPerSlide: t = 1 }) {
  return /* @__PURE__ */ i("div", { className: r["figure-slide"], children: l.map((e, u) => /* @__PURE__ */ i(
    "figure",
    {
      className: s([
        r["figure-slide__figure"],
        e != null && e.caption ? r["figure-slide--captioned-image"] : ""
      ]),
      style: {
        backgroundImage: `url(${e.url})`,
        flexBasis: `${100 / t}%`
      },
      title: e.altText !== "" ? e.altText : "",
      children: (e == null ? void 0 : e.caption) && /* @__PURE__ */ i("figcaption", { children: e.caption })
    },
    `figure-${u}`
  )) });
}
export {
  n as FigureSlide,
  n as default
};
